import { type ReactNode } from 'react';

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded-2xl bg-ink/[0.06] ${className}`} aria-hidden="true" />;
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center gap-3 py-12 text-center" role="alert">
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="h-10 w-10 text-primary-300"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8v5" strokeLinecap="round" />
        <circle cx="12" cy="16.5" r="0.6" fill="currentColor" stroke="none" />
      </svg>
      <p className="text-ink/70">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-xl bg-primary-600 px-5 py-2.5 font-semibold text-white shadow-card transition hover:bg-primary-700 active:scale-[0.98]"
      >
        Повторить
      </button>
    </div>
  );
}

export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-2 py-12 text-center">
      <div className="mb-1 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-primary-500">
        <svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M4 9h16v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9z" />
          <path d="M2 9h20M8 9V6m8 3V6" strokeLinecap="round" />
        </svg>
      </div>
      <p className="text-lg font-semibold text-ink">{title}</p>
      {hint && <p className="max-w-xs text-ink/60">{hint}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
